import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import Button from './Button';
import { NewContainer } from './styles';

import { faArrowTrendUp, faBookOpen, faBriefcase, faCoins, faHome, faNewspaper, faQuestionCircle, faSearch, faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isAppV2 } from '../../services/versionManager';

import XTimesLogoWhite from '../../assets/Airdrop/xtimes_logo_white_no_circle.svg';
import LensLogoWhite from '../../assets/Lens/lens_logo_white_no_circle.svg';

const NewMobileMenu: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { pathname: activePage, push } = useRouter();
  const [showMobileMenu, setShowMobileMenu] = useState(true);

  const [lastScrollPos, setLastScrollPos] = useState(0);

  const handleChangePage = (page: string) => {
    if (page.startsWith('/open-in-app')) {
      window.location.href = page;
    } else {
      push(page);
    }

    setShowMobileMenu(!page.startsWith('/discover'));
  };

  const menuItems = activePage.startsWith('/lens') && !activePage.startsWith('/lens/news') ? [
    // {
    //   'page': '/lens',
    //   'icon': faSearch
    // },
    {
      'page': '/lens/cryptos',
      'icon': faArrowTrendUp
    },
    {
      'page': '/lens/defi',
      'icon': faCoins
    },
    {
      'page': '/home',
      'custom-icon': (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', 
        height: '42px', width: '42px', border: '1px solid white', borderBottom: '3px solid white', borderRadius: '50%'
        }}>
          <FontAwesomeIcon icon={faHome} height={40} width={40} />
        </div>)
    },
    {
      'page': '/lens/education',
      'icon': faBookOpen
    },
    {
      'page': '/lens/portfolio',
      'icon': faBriefcase
    }
  ] : [
    {
      'page': '/home',
      'icon': faHome
    },
    // {
    //   'page': '/lens/cryptos',
    //   'icon': faArrowTrendUp
    // },
    // {
    //   'page': '/lens',
    //   'custom-icon': (
    //   <div style={{
    //     display: 'flex', alignItems: 'center', justifyContent: 'center', 
    //     height: '42px', width: '42px', border: '1px solid white', borderBottom: '3px solid white', borderRadius: '50%'
    //     }}>
    //       <LensLogoWhite height={36} width={36} />
    //     </div>)
    // },
    // {
    //   'page': '/lens/news',
    //   'icon': faNewspaper
    // },
    {
      // 'page': '/airdrop/xtimes/season',
      'page': '/announcement',
      'custom-icon': <XTimesLogoWhite height={32} width={32} />
    },
    {
      'page': '/cashback',
      'icon': faWallet
    },
    {
      'page': 'help',
      'icon': faQuestionCircle
    }
  ];

  useEffect(() => {
    setShowMobileMenu(
      !activePage.startsWith('/discover')
      &&
      !activePage.startsWith('/airdrop/[slug]/season')
    );
  }, [activePage]);

  const onScroll = useCallback(() => {
    if (window.location.pathname.startsWith('/discover')
      || window.location.pathname.startsWith('/airdrop/xtimes/season')) {
      return;
    }

    const scrollY = Math.max(0, window.scrollY);
    setShowMobileMenu(lastScrollPos > scrollY);

    setLastScrollPos(scrollY);
  }, [lastScrollPos]);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/discover') || path.startsWith('/airdrop/xtimes/season')) {
      setShowMobileMenu(false);
      return;
    }

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    }
  }, [onScroll]);

  return (
    <NewContainer className={showMobileMenu === true ? 'show' : 'hide'} style={{ padding: '0px 10px', paddingBottom: '14px' }}>
      <div id='hotjar_element_holder' style={{ padding: '0px 20px'}} />
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 60,
        border: activePage.startsWith('/airdrop') ? '1px solid #878787' : 'none',
        backgroundColor: 'black',
        borderRadius: 30,
        padding: '0px 10px'
      }}>
        {menuItems.filter(
          (value) => (isAppV2() || !value.page.startsWith('/open-in-app'))
        ).map((value, idx) => {
          return <Button
            key={idx}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingBottom: '0px' }}
            onClick={() => handleChangePage(value['page'])}
            $active={activePage === value['page'] || window.location.pathname === value['page']}
          >{value["custom-icon"]
              ? <div style={{ flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>{value["custom-icon"]}</div>
            : <FontAwesomeIcon fontSize='calc(15px + 0.390625vw)' icon={value['icon']} />}
          </Button>
        })}
      </div>
    </NewContainer>
  );
};

export default NewMobileMenu;
